// extracted by mini-css-extract-plugin
export default {"main":"courseContent_main__Sf-vR","accordions":"courseContent_accordions__WrRP8"};